/* global $ */

import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';
import getControllerForElement from '../helpers/getControllerForElement';

class OrderForm extends Controller {
  connect() {
    this.modal = document.querySelector('[data-controller="cart-tooltip"]');
    this.cartTooltipController = null;

    getControllerForElement(this.application, this.modal, 'cart-tooltip').then((controller) => {
      this.cartTooltipController = controller;
    });
  }

  onSubmit(event) {
    event.preventDefault();

    const title = this.element.querySelector('[name="product_variant_title"]').value;

    this.storeInCart();

    if (this.cartTooltipController) {
      this.cartTooltipController.attachProductVariantTitle(title);
      this.cartTooltipController.show();
    }
  }

  storeInCart() {
    const formData = new FormData(this.element);
    const productItemObj = JSON.parse(this.data.get('gtm-array'));

    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'addToCart',
        currency: 'EUR',
        value: productItemObj.price,
        items: [
          productItemObj,
        ],
      });
    }

    $.ajax({
      url: this.element.getAttribute('action'),
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      success: res => this.updateCartCount(res.items.length),
    });
  }

  // eslint-disable-next-line class-methods-use-this
  updateCartCount(count) {
    const output = toArray(document.querySelectorAll('.js-navigation-cart-item-count'));

    output.forEach((element) => {
      element.innerText = count;
    });
  }
}

OrderForm.targets = [
  'price',
  'quantityInput',
];

export default OrderForm;
